import { instanceToPlain, plainToInstance } from 'class-transformer';
import { useNavigate, useParams } from 'react-router-dom';
import { TypeMode } from 'constants/TypeMode';
import MissionForm from './components/mission-form/MissionForm';
import { useEdit } from 'hooks/useEdit';
import { ActionCloseReason } from 'constants/CloseReasonTypes';

import { useDispatch } from 'react-redux';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import MissionService from 'services/mission/MissionService';

// eslint-disable-next-line react/prop-types, no-unused-vars
const EditMissionPage = ({
    navigateTo,
    slice,
    service,
    pageTitle,
    config,
    entity,
}) => {
    const navigate = useNavigate();

    let { id } = useParams();

    const dispatch = useDispatch();
    const defaultValue = useSelector(state => state[slice]?.mission);
    // const [, status, defaultValue] = useEdit(
    //     // eslint-disable-next-line react/prop-types
    //     async () => service.getEntity(id),
    //     true,
    //     plainToInstance(entity, {}, { exposeDefaultValues: true }),
    // );

    useEffect(() => {
        dispatch(MissionService.getMissionById(id));
    }, [dispatch, id]);

    const handleOnClose = action => {
        navigate(navigateTo, {
            state: action === ActionCloseReason.Submit ? 'refresh' : null,
        });
    };

    const handleOnSubmit = async (data, successCallback, errorCallback) => {
        data = instanceToPlain(data);
        try {
            // eslint-disable-next-line react/prop-types
            // delete data.id;

            const response = await service.update(data);
            successCallback('Data saved');
        } catch (err) {
            errorCallback(err, 'An error occurred');
        }
    };

    return (
        <MissionForm
            title={pageTitle}
            mode={TypeMode.Edit}
            formConfig={config}
            defaultErrors={defaultValue?.errors}
            defaultValue={instanceToPlain(defaultValue)}
            onClose={handleOnClose}
            onSubmit={handleOnSubmit}
            originalMessage={defaultValue?.originalMessage}
            slice={slice}
        ></MissionForm>
    );
};

export default EditMissionPage;
